module.exports = __webpack_public_path__ + "static/media/history_category.d95ab075.jpg";